'use strict';
/**
 * @author Maxim Seredkin
 */
import angular from "angular";
import ProjectMaintenanceModalCreateController from "./controller/projectMaintenanceModalCreate";
import ProjectMaintenanceModalSelectController from "./controller/projectMaintenanceModalSelect";
import ProjectMaintenanceTableDirective from "./directive/projectMaintenanceTable";
import ProjectMaintenanceResponsibilityTableDirective from "./directive/projectMaintenanceResponsibilityTable";
import ProjectMaintenanceNodeDirective from "./directive/projectMaintenanceNode";
import ProjectMaintenanceTreeDirective from "./directive/projectMaintenanceTree";
import ProjectMaintenanceSelectDirective from "./directive/projectMaintenanceSelect";
import ProjectMaintenanceService from "./service/maintenance";

export default angular.module('investmentProject.project.maintenance', [])
    .controller('ProjectMaintenanceModalCreateController', ProjectMaintenanceModalCreateController)
    .controller('ProjectMaintenanceModalSelectController', ProjectMaintenanceModalSelectController)
    .directive('projectMaintenanceTable', ProjectMaintenanceTableDirective)
    .directive('projectMaintenanceResponsibilityTable', ProjectMaintenanceResponsibilityTableDirective)
    .directive('projectMaintenanceNode', ProjectMaintenanceNodeDirective)
    .directive('projectMaintenanceTree', ProjectMaintenanceTreeDirective)
    .directive('projectMaintenanceSelect', ProjectMaintenanceSelectDirective)
    .factory('ProjectMaintenanceService', ProjectMaintenanceService)
    .name;